export const SUBSCRIPTION_STATUS_TRIAL = 0;
export const SUBSCRIPTION_STATUS_ACTIVE = 1;
export const SUBSCRIPTION_STATUS_PAST_DUE = 2;
export const SUBSCRIPTION_STATUS_UNPAID = 3;
export const SUBSCRIPTION_STATUS_CANCELED = 4;
